import * as React from "react";
import {Icon, Label, Tab} from "semantic-ui-react";

import Button from "../../../components/Button";
import {OptionDto, OptionWorkflowStatusMultiUpdateParamActionType} from "../../../services/Client";

import DataAdapterOptionsView from "../DataAdapterOptionsView";

import {renderActionTypeLabel} from "./WSMUActionSelection";
import {IWSMUSummaryTableProps} from "./WSMUSummaryTable";
import {getInvalidItemsTab, getValidItemsTab, SelectType} from "./WSMUSummaryUtils";

export interface IWSMUSummaryProps {
    actionType: OptionWorkflowStatusMultiUpdateParamActionType;
    validItems: DataAdapterOptionsView[];
    invalidItems: DataAdapterOptionsView[];
    itemsToUpdate: Map<number, OptionDto>;
    t: reactI18Next.TranslationFunction;

    // actions
    handleSelectChange: (actionType: SelectType, optionDto?: OptionDto) => void;
    nextAction: () => void;
    backAction: () => void;
}

interface IWSMUSummaryState {
    validTablePage: number;
    invalidTablePage: number;
}

export class WSMUSummary extends React.Component<IWSMUSummaryProps, IWSMUSummaryState> {

    constructor(props: IWSMUSummaryProps) {
        super(props);

        this.state = {
            validTablePage: 1,
            invalidTablePage: 1
        };
    }

    private getTabs = () => {
        let tabs = [];

        if (this.props.validItems.length > 0) {
            const props: IWSMUSummaryTableProps = {
                actionType:this.props.actionType,
                totalItems: this.props.validItems,
                tablePage: this.state.validTablePage,
                itemsToUpdate: this.props.itemsToUpdate,
                t: this.props.t,
                validFlag: true,
                onChangePage: (pageNumber: number) => this.setState({validTablePage: pageNumber}),
                handleSelectChange: this.props.handleSelectChange
            };

            tabs.push(getValidItemsTab(props));
        }

        if (this.props.invalidItems.length > 0) {
            const props: IWSMUSummaryTableProps = {
                actionType:this.props.actionType,
                totalItems: this.props.invalidItems,
                tablePage: this.state.invalidTablePage,
                t: this.props.t,
                onChangePage: (pageNumber: number) => this.setState({invalidTablePage: pageNumber})
            };

            const disclaimer = this.props.actionType === OptionWorkflowStatusMultiUpdateParamActionType.RESET ? this.props.t("PSL_WF_S_MULTI:RESET_INVALID_DISCLAIMER") :
                this.props.actionType === OptionWorkflowStatusMultiUpdateParamActionType.MOVE_FORWARD ? this.props.t("PSL_WF_S_MULTI:MOVE_FORWARD_INVALID_DISCLAIMER") : '';

            tabs.push(getInvalidItemsTab(props, disclaimer));
        }

        return tabs;
    }

    render() {
        const {t} = this.props;
        const totalItemsCount = this.props.validItems.length + this.props.invalidItems.length;

        return (
            <>

                <div style={{marginBottom: '20px'}}>
                    <p>
                        <b>{this.props.t("PSL_WF_S_MULTI:ACTION_TYPE")}</b>
                        {': ' + renderActionTypeLabel(this.props.actionType, this.props.t)}
                    </p>

                    <p>
                        <b>{totalItemsCount}</b>
                        {' ' + t(totalItemsCount === 1 ? "PSL_WF_S_MULTI:ALL_ITEMS_COUNT_SINGLE" : "PSL_WF_S_MULTI:ALL_ITEMS_COUNT_MULTI")}
                    </p>

                    {this.props.validItems.length > 0 &&
                        <p>
                            <b style={{color: 'green'}}>{this.props.validItems.length}</b>
                            {' ' + t(this.props.validItems.length === 1 ? "PSL_WF_S_MULTI:VALID_ITEMS_COUNT_SINGLE" : "PSL_WF_S_MULTI:VALID_ITEMS_COUNT_MULTI") +
                                ' ' + t("PSL_WF_S_MULTI:VALID_ITEMS_COUNT_TXT", {tab: t("PSL_WF_S_MULTI:VALID_ITEMS_TAB")})}
                        </p>
                    }

                    {this.props.invalidItems.length > 0 &&
                        <div className={"display--flex"}>
                            <Icon name="warning sign" color="red" />
                            <p>
                                <b style={{color: 'red'}}>{this.props.invalidItems.length}</b>
                                {' ' + t(this.props.invalidItems.length === 1 ? "PSL_WF_S_MULTI:INVALID_ITEMS_COUNT_SINGLE" : "PSL_WF_S_MULTI:INVALID_ITEMS_COUNT_MULTI") +
                                    ' ' + t("PSL_WF_S_MULTI:INVALID_ITEMS_COUNT_TXT", {tab: t("PSL_WF_S_MULTI:INVALID_ITEMS_TAB")})}
                            </p>
                        </div>
                    }
                </div>

                <Tab
                    id={'psl-wsmu-summary'}
                    panes={this.getTabs()}
                    menu={{pointing: true}}
                    className={'scrollbarX'}
                />

                <div style={{marginTop: '30px'}}>
                    <Button
                        icon={'arrow left'}
                        onClick={this.props.backAction}
                    />
                    {this.props.validItems.length > 0 &&
                        <div style={{float: 'right'}}>
                            {this.props.itemsToUpdate.size === 0 &&
                                <Label color={'red'} pointing={'right'}>
                                    <Icon name={'warning'} />
                                    {this.props.t("PSL_WF_S_MULTI:EMPTY_LIST_HINT")}
                                </Label>}
                            <Button
                                icon={'arrow right'}
                                style={{float: 'right'}}
                                disabled={this.props.itemsToUpdate.size === 0}
                                onClick={this.props.nextAction}
                            />
                        </div>
                    }
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUSummary.tsx